export const MIXED_GRID_SORT_OPTIONS = {
  pertinenceAsc: {
    order: 'asc',
    field: 'pertinence',
    label: 'Search.Sort.Pertinence',
  },
  publicationDesc: {
    order: 'desc',
    field: 'publication_date',
    label: 'Search.Sort.Novelties',
  },
  priceAsc: {
    order: 'asc',
    field: 'price_position',
    label: 'Search.Sort.PriceAsc',
  },
  priceDesc: {
    order: 'desc',
    field: 'price_position_desc',
    label: 'Search.Sort.PriceDesc',
  },
};

export const DEFAULT_SORT = 'pertinenceAsc';

export const getFilterById = (filters, filterId) => filters.find((filter) => filter.id === filterId);

export const getFilterItemFromIdAndValue = (filters, filterId, value) =>
  getFilterById(filters, filterId).items.find((item) => item.value === value);
